export default __webpack_public_path__ + "static/media/banner-zapay.e3c78266.png";